class GestationalAge {
    public NumberOfWeeks?: string = "";
    public NumberOfDays?: string = "";

    public get NumberOfWeeksNumber(): number {
        return Number(this.NumberOfWeeks ?? 0);
    }

    public get NumberOfDaysNumber(): number {
        return Number(this.NumberOfDays ?? 0);
    }

    public get TotalNumberOfDays(): number {
        return this.NumberOfWeeksNumber * 7 + this.NumberOfDaysNumber;
    }

    constructor(fields?: Partial<GestationalAge>) {
        Object.assign(this, fields);
    }

    public hasValue(): boolean {
        return !!this.NumberOfWeeks
            || !!this.NumberOfDays;
    }
}

export { GestationalAge };
